
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/premarket",
      function () {
        return require("private-next-pages/embed/premarket.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/premarket"])
      });
    }
  